module.exports = __webpack_public_path__ + "media/images/how_it_works/3-e14c0670a994d95c7ec46b2ccb4ee607.svg";